"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntersectionObserver = require("react-intersection-observer");
var _ExpandableCard = _interopRequireDefault(require("./ExpandableCard"));
var _OriginalCard = _interopRequireDefault(require("./OriginalCard"));
var _constants = require("../constants");
var Card = function Card(props) {
  var _useInView = (0, _reactIntersectionObserver.useInView)({
      rootMargin: _constants.LAZY_LOAD_OFFSET,
      triggerOnce: true
    }),
    ref = _useInView.ref,
    inView = _useInView.inView;
  return props.expandable ? /*#__PURE__*/_react["default"].createElement(_ExpandableCard["default"], (0, _extends2["default"])({
    intersectionRef: ref
  }, props, {
    inView: inView
  })) : /*#__PURE__*/_react["default"].createElement(_OriginalCard["default"], (0, _extends2["default"])({
    intersectionRef: ref
  }, props, {
    inView: inView
  }));
};
Card.propTypes = {
  expandable: _propTypes["default"].bool
};
var _default = exports["default"] = Card;